import React from 'react';

export default function App() {
  const styles = {
    container: {
      minHeight: '100vh',
      background: 'linear-gradient(to bottom right, #ffffff, #f9fafb, #f3f4f6)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },
    wrapper: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '4rem 1.5rem',
    },
    header: {
      textAlign: 'center',
      marginBottom: '4rem',
    },
    mainHeading: {
      fontSize: 'clamp(2.5rem, 8vw, 4.5rem)',
      fontWeight: '300',
      letterSpacing: '-0.02em',
      color: '#000',
      marginBottom: '1.5rem',
    },
    subHeading: {
      fontSize: 'clamp(1.25rem, 3vw, 1.5rem)',
      fontWeight: '300',
      color: '#1f2937',
      marginBottom: '1rem',
    },
    comingSoon: {
      fontSize: '1.125rem',
      color: '#6b7280',
      fontWeight: '300',
    },
    imageGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: '2rem',
      marginBottom: '4rem',
    },
    imagePlaceholder: {
      aspectRatio: '1 / 1',
      background: 'linear-gradient(to bottom right, #e5e7eb, #d1d5db)',
      borderRadius: '0.5rem',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
    },
    imageStyle: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    placeholderText: {
      color: '#9ca3af',
      fontWeight: '300',
      fontSize: '0.875rem',
      textAlign: 'center',
      padding: '2rem',
    },
    linkSection: {
      textAlign: 'center',
    },
    instagramLink: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.75rem',
      color: '#000',
      textDecoration: 'none',
      fontSize: '1.125rem',
      fontWeight: '300',
      letterSpacing: '0.02em',
      transition: 'color 0.3s ease',
    },
    instagramHandle: {
      fontSize: '0.875rem',
      color: '#6b7280',
      marginTop: '0.5rem',
      fontWeight: '300',
    },
    footer: {
      textAlign: 'center',
      marginTop: '4rem',
      paddingTop: '2rem',
      borderTop: '1px solid #e5e7eb',
    },
    footerText: {
      fontSize: '0.875rem',
      color: '#6b7280',
      fontWeight: '300',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.wrapper}>
        {/* Header Section */}
        <div style={styles.header}>
          <h1 style={styles.mainHeading}>
            Hi, I'm Asme
          </h1>
          <p style={styles.subHeading}>
            Something beautiful is being crafted
          </p>
          <p style={styles.comingSoon}>
            Website coming soon
          </p>
        </div>

        {/* Image Gallery Grid */}
        <div style={styles.imageGrid}>
          {/* Image 1 - Replace src with your image path */}
          <div style={styles.imagePlaceholder}>
            <img 
              src="/images/ceramics-photo-1.jpg" 
              alt="Ceramic work 1" 
              style={styles.imageStyle}
            />
           
            {/* <div style={styles.placeholderText}>
              Replace with your ceramic image
              <br />
              (e.g., /images/ceramic1.jpg)
            </div> */}
          </div>

          {/* Image 2 - Replace src with your image path */}
          <div style={styles.imagePlaceholder}>
            <img 
              src="/images/ceramics-photo-2.jpg" 
              alt="Ceramic work 2" 
              style={styles.imageStyle}
            />
           
            {/* <div style={styles.placeholderText}>
              Replace with your ceramic image
              <br />
              (e.g., /images/ceramic2.jpg)
            </div> */}
          </div>

          {/* Image 3 - Replace src with your image path */}
          <div style={styles.imagePlaceholder}>
            <img 
              src="/images/ceramics-photo-3.JPG" 
              alt="Ceramic work 3" 
              style={styles.imageStyle}
            />
           
            {/* <div style={styles.placeholderText}>
              Replace with your ceramic image
              <br />
              (e.g., /images/ceramic3.jpg)
            </div> */}
          </div>
        </div>

        {/* Instagram Link Section */}
        <div style={styles.linkSection}>
          <a
            href="https://instagram.com/asme.ceramics"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.instagramLink}
            onMouseOver={(e) => e.currentTarget.style.color = '#6b7280'}
            onMouseOut={(e) => e.currentTarget.style.color = '#000'}
          >
            <svg 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2"
            >
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
            </svg>
            <span>Follow me on Instagram</span>
          </a>
          <p style={styles.instagramHandle}>
            {/* TODO: Replace with your Instagram handle */}
            @asme.ceramics
          </p>
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <p style={styles.footerText}>
            © 2026 Asme Sheikh. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}